import {
    PENDING_SURVEY,
    START_BRIEF_SURVEY,
    NEW_VALIDATION_TOKEN,
    RESET_VALIDATION_TOKEN,
    UPDATE_STORED_RESPONSE,
    UPDATE_BRIEF_RESPONSE,
    UPDATE_BRIEF_RESPONSE_ANSWERS,
    POST_BRIEF_RESPONSE,
    CLEAR_ANSWER,
    CLEAR_ALL,
} from "constants/actions";


const initialState = {
    id: null,
    pending: false,
    validation_token: false,
    modular_questions: [],
    survey_token: false,
    debrief_schedule: false,
    employee: false,
    survey_status: 0,
    token_status: 0,
    questions: [],
    employee_category: [],
    intro_completed: false,
    valid_upto: false,
    is_demo: false,
    is_schedule_open: false,
    feedback: [],
    modular_response: {},
    answers: {},
    visual_question: 0,
    current_question: 0,
    current_answer: 0,
    high_answer: 0,
    complete: false,
    questionSequenceMap: {},
};

export default function BriefResponse(state = initialState, action) {
    // console.log(action.payload)
    switch (action.type) {
        case PENDING_SURVEY:
            return {
                ...state,
                pending: true
            }
        case START_BRIEF_SURVEY: {
            // payload can be an array with a single session object
            const item = Array.isArray(action.payload) ? action.payload[0] : (action.payload || {});

            // top-level
            const token_status = item.token_status ?? 0;
            const token = item.token ?? null;
            const valid_upto = item.valid_upto ?? null;
            const is_demo = item.is_demo ?? false;
            const is_schedule_open = item.is_schedule_open ?? false;
            const debrief_schedule = item.debrief_schedule ?? null;

            // grouped objects from the new serializer
            const organization = item.organization || {};
            const employee = item.employee || {};
            const employee_category = employee.category || [];

            // categories & outcomes (new names/locations)
            const categories = item.categories || [];
            const outcomes = item.outcomes || null;

            // main question object and counts
            const questionsObj = item.questions || {};          // { type, title, factors: [...] }
            const factors = Array.isArray(questionsObj.factors) ? questionsObj.factors : [];
            const min_followup = item.min_followup ?? null;
            const max_followup = item.max_followup ?? null;

            // stored_response comes back nested; also carries questionSequenceMap
            const stored_response = item.stored_response || {};
            const questionSequenceMap = stored_response.questionSequenceMap || {};

            // answers/UI progress from stored_response if present
            const answers = stored_response.answers || {};
            const intro_completed = !!stored_response.intro_completed;
            const current_question = stored_response.current_question ?? 0;
            const current_answer = stored_response.current_answer ?? 0;
            const high_answer = stored_response.high_answer ?? 0;
            const complete = !!stored_response.complete;

            return {
                ...state,
                pending: false,

                // flat fields
                id: item.id ?? null,
                survey_token: token,
                valid_upto,
                is_demo,
                is_schedule_open,
                debrief_schedule,
                token_status: token_status,
                deleted_on: item.deleted_on,
                survey_status: item.survey_status,

                organization,
                employee,
                employee_category,

                categories,
                outcomes,
                questions: questionsObj,           

                min_followup,
                max_followup,

                // stored response & sequence
                stored_response,
                questionSequenceMap,

                // progress/answers
                answers,
                intro_completed,
                current_question,
                current_answer,
                high_answer,
                complete,

                // feedback and outcomes
                feedback: stored_response.feedback || [],
                modular_response: stored_response.modular_response || {},
            };
        }

        case UPDATE_STORED_RESPONSE:
            return {
                ...state,
                showing_stored_response: action.payload,
                pending: false,
            }
        case UPDATE_BRIEF_RESPONSE:
            return {
                ...state,
                ...action.payload,
                pending: false
            }
        case UPDATE_BRIEF_RESPONSE_ANSWERS:
            return {
                ...state,
                ...action.payload,
                pending: false
            }
        case NEW_VALIDATION_TOKEN:

            return {
                ...state,
                validation_token: action.payload,
                pending: false,
            }

        case RESET_VALIDATION_TOKEN:
            localStorage.clear();
            return {
                ...state,
                validation_token: false,
                pending: false,
            }
        case POST_BRIEF_RESPONSE:
            return {
                ...state,
                ...action.payload,
                pending: false
            }
        case CLEAR_ANSWER:
            return {
                ...state,
                survey_token: false,
                validation_token: false,
                debrief_schedule: false,
                employee: false,
                answers: {},
                questions: [],
                valid_upto: false,
                total_questions: 0,
                visual_question: 0,
                current_question: 0,
                current_answer: 0,
                high_answer: 0,
                complete: false,
                questionSequenceMap: {},
            };

        case CLEAR_ALL:
            return {
                ...state,
                survey_token: false,
                validation_token: false,
                debrief_schedule: false,
                employee: false,
               answers: {},
               questions: [],
                valid_upto: false,
                visual_question: 0,
                current_question: 0,
                current_answer: 0,
                high_answer: 0,
                complete: false,
                questionSequenceMap: {},
            };
        default:
            return state;
    }
}
